(() => {
  function handleize(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function applyStateAnchors(root = document) {
    root.querySelectorAll?.('.vz-state-card').forEach((card) => {
      if (card.id) return;
      const title = card.querySelector('h3')?.textContent;
      const handle = handleize(title);
      if (handle) card.id = `state-${handle}`;
    });

    const hash = window.location.hash.slice(1);
    const target = hash ? document.getElementById(hash) : null;
    if (target) {
      window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyStateAnchors(), { once: true });
  } else {
    applyStateAnchors();
  }

  document.addEventListener('shopify:section:load', (event) => applyStateAnchors(event.target));
})();
